// extracted by mini-css-extract-plugin
export default {"Chip":"style-module--Chip--k7Kci","icon":"style-module--icon--S+aP-"};